<template>
  <section class="service__section position-relative see__pad">
    <div class="pattern-layer">
      <div
        class="pattern-5 position-absolute"
        style="background-image: url('/shapes/shape-07.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-6 position-absolute"
        style="background-image: url('/shapes/shape-08.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-7 position-absolute"
        style="background-image: url('/shapes/shape-09.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-8 position-absolute"
        style="background-image: url('/shapes/shape-10.png')"
      ></div>
    </div>

    <div class="container">
      <div class="service__data">
        <div class="title__data">
          <div class="sub__title">
            <h4>{{ content.sectionLabel }}</h4>
          </div>
          <div class="title">
            <h2>{{ content.sectionTitle }}</h2>
          </div>
        </div>
        <div class="row">
          <div
            class="col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated"
            v-for="(product, index) in content.products"
            :key="index"
            :data-wow-delay="`${index * 200}ms`"
            data-wow-duration="1500ms"
          >
            <div class="service__block">
              <div class="service__icon">
                <i :class="product.icon"></i>
              </div>
              <div class="service__text">
                <h4>
                  <router-link :to="product.link">{{ product.title }}</router-link>
                </h4>
                <p>{{ product.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SynergyItsProductComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Better Future",
        sectionTitle: "Product Categories",
        products: [
          {
            title: "Enterprise Apps",
            description: "Comprehensive business solutions designed for large organizations with complex workflows and requirements.",
            icon: "icon-01",
            link: "/services"
          },
          {
            title: "SaaS Platforms",
            description: "Cloud-based software solutions that provide scalable, subscription-based services for modern businesses.",
            icon: "icon-02",
            link: "/services"
          },
          {
            title: "Internal Tools",
            description: "Custom tools and applications designed to streamline internal processes and improve team productivity.",
            icon: "icon-03",
            link: "/services"
          },
          {
            title: "Mobile Applications",
            description: "Native and cross-platform mobile apps that deliver exceptional user experiences across all devices.",
            icon: "icon-04",
            link: "/services"
          },
          {
            title: "Web Applications",
            description: "Modern web applications built with cutting-edge technologies for optimal performance and user experience.",
            icon: "icon-05",
            link: "/services"
          },
          {
            title: "AI Solutions",
            description: "Artificial intelligence and machine learning solutions that automate processes and provide intelligent insights.",
            icon: "icon-06",
            link: "/services"
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Import Flaticon */
@import "@/assets/scss/Flaticon.scss";

.see__pad {
  padding: 100px 0;
}

.auto-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.pattern-5 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-6 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-7 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-8 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Service Section - ReactJS Style */
.service__section {
  background: #00061a;
  position: relative;
  overflow: hidden;
}

.service__data {
  position: relative;
  z-index: 2;
}

.title__data {
  text-align: center;
  margin-bottom: 60px;
  padding-left: 0px;
}

.sub__title h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #f6ec4f;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
  text-transform: uppercase;
}

.title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 0;
  font-family: "Archivo", sans-serif;
}

.service__block {
  border-radius: 15px;
  padding: 40px 30px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
}

.service__block:hover {
  transform: translateY(-10px);
}

.service__icon {
  position: relative;
  margin-bottom: 25px;
  display: inline-block;
}

.service__icon i {
  font-size: 48px;
  color: #f6ec4f;
  display: inline-block;
  width: 80px;
  height: 80px;
  line-height: 80px;
  background: rgba(246, 236, 79, 0.1);
  border-radius: 50%;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.service__block:hover .service__icon i {
  background: #f6ec4f;
  color: #00061a;
  transform: scale(1.1);
}

.service__text h4 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: "Archivo", sans-serif;
}

.service__text h4 a {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease;
}

.service__text h4 a:hover {
  color: #f6ec4f;
}

.service__text p {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Open Sans", sans-serif;
}

.service__button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  opacity: 0;
  transition: all 0.3s ease;
}

.service__button a {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: #f6ec4f;
  color: #00061a;
  border-radius: 50%;
  line-height: 40px;
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.service__button a:hover {
  background: #fff;
  transform: scale(1.1);
}

.service__block:hover .service__button {
  opacity: 1;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .see__pad {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .see__pad {
    padding: 60px 0;
  }

  .title h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .pattern-5,
  .pattern-6,
  .pattern-7,
  .pattern-8 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .see__pad {
    padding: 40px 0;
  }

  .title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .sub__title h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }

  .service__block {
    padding: 30px 20px;
  }
}
</style>
